// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__35AsT","imageUploader":"EGiftCard_imageUploader__9ldcz"};